import { createAction, props, union } from '@ngrx/store';
import { AccountingYear } from 'app/api/company.api.service';
import { CompanyFilterInput } from 'app/api/API.service';
import { Period } from '../company.types';

const source = 'companies';
const actions = 'ui';

export const setCompaniesFilter = createAction(`[${source}][${actions}] Set Companies Filter`, props<{ filter: CompanyFilterInput | null }>());
export const setCurrentCompany = createAction(`[${source}][${actions}] Set Current Company`, props<{ companyId: string }>());
export const resetCurrentPeriod = createAction(`[${source}][${actions}] resetCurrentPeriod`);
export const setCurrentPeriod = createAction(`[${source}][${actions}] setCurrentPeriod`, props<{ period: Period }>());

const all = union({
  setCompaniesFilter,
  setCurrentCompany,
  resetCurrentPeriod,
  setCurrentPeriod,
});

export type CompaniesUIActionsUnion = typeof all;
